import { useMutation } from "@tanstack/react-query";
import { saveAs } from "file-saver";
import { privateApi } from "../../../api/api";
import { toast } from "sonner";

const API_VERSION = "v4";

/**
 * Custom hook untuk mengunduh template Import Rates (xlsx).
 * Menggunakan useMutation karena aksi dipicu pengguna, meskipun metode GET.
 */
export const useDownloadRatesTemplate = () => {
    return useMutation({
        mutationFn: async (propertyId: string) => {
            if (!propertyId) {
                throw new Error("Property ID is required to download the template.");
            }

            return await privateApi.get(`/${API_VERSION}/rate-import/template`, {
                params: {
                    property_id: propertyId,
                },
                responseType: "blob",
            });
        },
        onSuccess: (response) => {
            saveAs(new Blob([response.data]), "rate-import-template.xlsx");
            toast.success("Template downloaded successfully.");
        },
        onError: (error: any) => {
            toast.error(
                error?.response?.data?.message || "Failed to download template."
            );
        },
    });
};
